declare namespace $ {

	type $shm_hitalama_resizer_side__resize_side_shm_hitalama_page_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_page['resize_side'] >
		,
		ReturnType< $shm_hitalama_resizer_side['resize_side'] >
	>
	type $shm_hitalama_resizer_side__width_min_shm_hitalama_page_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_page['width_min'] >
		,
		ReturnType< $shm_hitalama_resizer_side['width_min'] >
	>
	type $shm_hitalama_resizer_side__width_max_shm_hitalama_page_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_page['width_max'] >
		,
		ReturnType< $shm_hitalama_resizer_side['width_max'] >
	>
	export class $shm_hitalama_page extends $mol_page {
		width_px( ): ReturnType< ReturnType< $shm_hitalama_page['Side_resizer'] >['width_px'] >
		Side_resizer( ): $shm_hitalama_resizer_side
		resize_side( ): string
		width_min( ): number
		width_max( ): number
		style( ): ({ 
			'width': ReturnType< $shm_hitalama_page['width_px'] >,
			'flexBasis': ReturnType< $shm_hitalama_page['width_px'] >,
		})  & ReturnType< $mol_page['style'] >
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=page.view.tree.d.ts.map